<template>
  <div>
    <v-divider v-if="$vuetify.display.mdAndUp || index > 0"/>
    <v-list-item
        class="px-0"
    >
      <v-row no-gutters="true">
        <v-col align-self="center">
          <v-row no-gutters="true">
            <v-col
                cols="2"
                align-self="center"
            >
              <v-skeleton-loader type="text"/>
            </v-col>
            <v-col
                cols="8"
                align-self="center"
            >
              <v-skeleton-loader type="text"/>
            </v-col>
            <v-col
                cols="2"
                align-self="center"
            >
              <v-skeleton-loader type="avatar"/>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-list-item>
  </div>
</template>

<script>
export default {
  name: "InvoiceListItemSkeleton"
}
</script>

<style scoped>

</style>